import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'cuit'
})
export class CuitPipe implements PipeTransform {
  transform(value: any, arg: string) : string {

    let newValue = String(value);

    if (!newValue || !newValue.length) {
      return null;
    }

    if (newValue.length !== 11) {
      return 'CUIT No válido';
    }

    return newValue.substr(0, 2) + '-' + newValue.substr(2, 8) + '-' + newValue.substr(10);
  }
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/utils/pipes/cuit.ts